import React, { Component } from 'react';
import axios from 'axios';
import {path} from './routes.js';
import Input from '../component/Input.js';
import Modal from 'react-modal';
import sparkles2 from '../asset/img/sparkles2.png';
import SelectBox from '../component/Select.js';
import loader from '../asset/img/loader.gif';
import Validation from './Validation.js';

export default class CreateASMPrize extends Component{
	constructor(props){
		super(props);
		this.handleInput = this.handleInput.bind(this);
		this.handleFile = this.handleFile.bind(this);
		this.onCreate = this.onCreate.bind(this);
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.fileInput = React.createRef();
		this.isImage = this.isImage.bind(this);
		this.loadingFunc = this.loadingFunc.bind(this);
		this.state = {prize:'',tier:'1',price:'',quantity:'',threshold:'',picture:[],description:'',modalPrompt:'',modalIsOpen:false,loading:false};
	}

	handleInput(identity,value){ //standard method for updating the state based on user input
		const theState = this.state;
		theState[identity] = value;
		this.setState(theState);
	}

	loadingFunc(loading){ //method for displaying the loading gif
		if(loading){
			this.setState({loading:true},function(){
				this.openModal();
			});
		}else{
			this.setState({loading:false});
		}
	}

	openModal(){ //method for opening the modal
		this.setState({modalIsOpen:true});
	}

	closeModal(){ //method for closing the modal
		this.setState({modalIsOpen:false,modalPrompt:''});
		this.props.revertSave();
	}

	isImage(file){ //method to determine whether or not an uploaded file is an image (validate file uploads to prevent malicious code/programs from being uploaded)
		 return (file['type'].split('/')[0] == 'image');
	}

	handleFile(){ //method that records name of uploaded picture for file storage
		let fileName = "asm_"+this.fileInput.current.files[0].name; 
		this.setState({picture:fileName});
	}

	onCreate(newPrize){ //method to create main prize information (tier, year, type, picture path, name of prize, description)
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'create',table:'prizes',misc:'create',firstID:newPrize.tier,secondID:this.props.year,status:'asm',name:newPrize.prize,picture:newPrize.picture,desc:newPrize.description}
		}).then((response)=>{
			let data = response.data.data;
			if(data.ID !== 0){ //if prize information was created, continue
				this.putPrice(data.ID);
			}else{
				this.setState({modalPrompt:"Gift already exists!"},function(){
					this.openModal();
				});
			}
		});
	}

	putPrice(prizeID){ //method for saving the price of prize/gift being created, the quantity in inventory, and the "low inventory" threshold
		axios({ //store price
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'create',table:'pricing',firstID:prizeID,cost:this.state.price}
		}).then((response)=>{
			this.setState({prize:'',tier:'',price:'',picture:'',description:''});
		});
		axios({ //store quantity and threshold
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'create',table:'inventory',misc:'create',firstID:prizeID,quantity:this.state.quantity,secondID:this.state.threshold}
		}).then((response)=>{
			this.props.revertSave();
			this.setState({threshold:'',quantity:'',modalPrompt:'Gift successfully created!'},function(){
				this.loadingFunc(false);
				this.props.onClose(this.props.year);
			});
		});
	}

	componentDidUpdate(prevProps,prevState){
		const {prize,tier,picture,description,price,quantity,threshold} = this.state;
		if(prevProps.save !== this.props.save && this.props.save){ //if user has chosen to save/create prize
			if(picture.length > 0 && tier !== '' && prize !== '' && description !== '' && price !== '' && price > 0 && quantity !== '' && threshold !== ''){ //make sure all fields have been filled out
				if(Validation("prize",prize) && Validation("prize",description) && this.isImage(this.fileInput.current.files[0])){ //if fields contain valid input, create prize
					this.loadingFunc(true);
					document.getElementById("desc").classList.remove("invalid");
					document.getElementById("prize").classList.remove("invalid");
					let data = new FormData();
					data.append('file[]',this.fileInput.current.files[0],"asm_"+this.fileInput.current.files[0].name);
					axios({
					 	method:'post',
					 	url:path,
					 	headers:{'Content-Type':'application/json'},
					 	data:data
					 }).then((response)=>{
					 	this.onCreate(this.state);
					 });
				}else{ //fields dont contain valid input
					let modalPrompt = '';
					if(!Validation("prize",prize) || !Validation("prize",description)){ //prize name or description do not contain valid input
						modalPrompt += 'Fields must contain valid input. No special characters.';
					}
					if(!this.isImage(this.fileInput.current.files[0])){ //file is not an image, only images are allowed for file upload
						modalPrompt += 'Only images are allowed to be uploaded.';
					}
					this.setState({modalPrompt:modalPrompt},function(){
						this.openModal();
					});
					if(!Validation("prize",prize)){ //highlight prize name input
						document.getElementById("prize").classList.add("invalid");
					}else{
						document.getElementById("prize").classList.remove("invalid");
					}
					if(!Validation("prize",description)){ //highlight description input
						document.getElementById("desc").classList.add("invalid");
					}else{
						document.getElementById("desc").classList.remove("invalid");
					}
					if(!this.isImage(this.fileInput.current.files[0])){ //highlight image upload lable
						document.getElementById("pic").classList.add("invalidLabel");
					}else{
						document.getElementById("pic").classList.remove("invalidLabel");
					}
				}
			}else{
				if(picture.length === 0){ //highlight image upload lable
					document.getElementById("pic").classList.add("invalidLabel");
				}else{
					document.getElementById("pic").classList.remove("invalidLabel");
				}
				if(prize === ''){ //highlight prize name input
					document.getElementById("prize").classList.add("invalid");
				}else{
					document.getElementById("prize").classList.remove("invalid");
				}
				if(description === ''){ //highlight description input
					document.getElementById("desc").classList.add("invalid");
				}else{
					document.getElementById("desc").classList.remove("invalid");
				}
				if(price === '' || price <= 0){ //highlight price input field
					document.getElementById("price").classList.add("invalid");
				}else{
					document.getElementById("price").classList.remove("invalid");
				}
				if(quantity === ''){ //highlight quantity input field
					document.getElementById("qty").classList.add("invalid");
				}else{
					document.getElementById("qty").classList.remove("invalid");
				}
				if(threshold === ''){ //highlight threshold input field
					document.getElementById("thresh").classList.add("invalid");
				}else{
					document.getElementById("thresh").classList.remove("invalid");
				}

				this.setState({modalPrompt:'All fields are required.'},function(){
					this.openModal();
				});
			}
		}
	}

	render(){
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'400px',
		    minWidth:'300px',
		    minHeight:'160px',
		    borderStyle:'solid',
		    borderWidth:'2px',
		    borderColor:'gray',
		    transform: 'translate(-50%, -50%)',
		    backgroundImage:'url('+sparkles2+')',
		    backgroundRepeat:'no-repeat',
		    backgroundSize: '300px 160px',
		    backgroundPosition:'right',
		    boxShadow:'0.5px 0.5px 1px 0.5px'
			}, 
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			} 
		};
		let modalContent;
		if(this.state.loading){ //either display loading gif or message
			modalContent = <div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>;
		}else{
			modalContent = <p className="b navy tc mt3 f4">{this.state.modalPrompt}</p>;
		}
		const inputStyles = "h2 br2 bw1 w-100 shadow-3 pl2 pr2";
		const areaStyles="br2 bw1 h3 w-100 shadow-3 pa2";
		return(
			<div className="fl w-100" style={{maxWidth:'900px',margin:'auto'}}>
				<div className="fl w-100 mt4">
					<div className="fl w-50-ns w-100 mt0-ns mt3-m">
						<div className="fl w-100">
							<label className="b">Gift name: </label>
						</div>
						<div className="fl w-100 pr2">
							<Input identity="prize" onInput={this.handleInput} id="prize" val={this.state.prize} inputStyle={inputStyles}/>
						</div>
					</div>
					<div className="fl w-25-ns w-50 mt0-ns mt3-m mt3">
						<div className="fl w-100">
							<label className="b">Tier: </label>
						</div>
						<div className="fl w-100 pr2">
							<SelectBox name="tier" identity="tier" onSelect={this.handleInput} options={this.props.tiers} styles={inputStyles} val={this.state.tier}/>
						</div>
					</div>
					<div className="fl w-25-ns w-50 mt0-ns mt3-m mt3">
						<div className="fl w-100">
							<label className="b">Price: </label>
						</div>
						<div className="fl w-100 pr2">
							<Input identity="price" id="price" onInput={this.handleInput} val={this.state.price} inputStyle={inputStyles} type="number"/>
						</div>
					</div>
				</div>
				<div className="fl w-100 mt3-m mt3-ns">
					<div className="fl w-50-ns w-100-m w-100 mv3">
						<div className="fl w-20">
							<label id="pic" className="b">Picture: </label>
						</div>
						<div className="fl w-80 pr2">
							<div className="ml2-ns">
								<input type="file" name="files" onChange={this.handleFile} ref={this.fileInput} accept="image/*"/>
							</div>
						</div>
					</div>
					<div className="fl w-25-ns w-50-m w-100 mt2">
						<div className="fl w-100">
							<label className="b">Notification Threshold: </label>
						</div>
						<div className="fl w-100 pr2">
							<Input identity="threshold" id="thresh" onInput={this.handleInput} val={this.state.threshold} inputStyle="h2 br2 bw1 w-100 shadow-3 pl2 pr2 mr2-ns mr2-m" type="number"/>
						</div>
					</div>
					<div className="fl w-25-ns w-50-m w-100 mt2">
						<div className="fl w-100">
							<label className="b">Quantity: </label>
						</div>
						<div className="fl w-100 pr2">
							<Input identity="quantity" id="qty" onInput={this.handleInput} val={this.state.quantity} inputStyle="h2 br2 bw1 w-100 shadow-3 pl2" type="number"/>
						</div>
					</div>
				</div>
				<div className="fl w-100 mt3">
					<div className="fl w-100">
						<label className="b">Description: </label>
					</div>
					<div className="fl w-100 tl pr2">
						<Input type="text" identity="description" id="desc" inputStyle={inputStyles} onInput={this.handleInput} val={this.state.description}/>
					</div>
				</div>
				<div>
					<Modal
		          isOpen={this.state.modalIsOpen}
		          style={customStyles}
		          contentLabel="loading"
		          shouldCloseOnOverlayClick={false}
		          shouldCloseOnEsc={false}
		        >
		        <div className="fl w-100 tr">
		        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
		        </div>
		        {modalContent}
		        </Modal>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/CreateASMPrize.js